module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8023.89b3eae3.png";